// src/lib/sectorTheses.js
// 섹터별 투자 논거(thesis) + 이벤트 캘린더. 이벤트는 리서치 기반이라 일 1회 갱신 대상.
// source: "user"=사용자 리서치, "auto"=일일 자동 생성(예정).
export const SECTOR_THESES = {
  "유틸리티": {
    asof: "2026-08-07",
    tag: "원전",
    source: "user",
    summary: "수급이 깔끔하게 비어있는 섹터. 1년간 정책·금융·구조 설계를 마치고 소강 국면 진입. 하반기부터 사업자·부지가 특정된 개별 프로젝트가 본격화 — 구체화 뉴스가 나올 때마다 강한 숏스퀴즈·상승이 기대됨.",
    drivers: [
      "정책·구조 설계 마무리 → 실행 단계 진입",
      "개별 프로젝트(사업자·부지) 구체화",
      "한국의 대미 원전 투자 집행",
      "Holtec: 퇴역원전 재가동·SMR·IPO",
    ],
    catalysts: [
      { date: "2026-08", text: "유틸리티사 5~7곳 신규원전 건설 의사 표명" },
      { date: "2026-08~09", text: "Palisades 재가동(미국 최초 퇴역원전 재가동) · Holtec IPO" },
      { date: "2026-09", text: "Oyster Creek 해체계획 최종승인(SMR 예정 부지) 후속" },
      { date: "2026-10", text: "Supply Chain Loan 지원대상 5개 발표 · 한국의 대미 원전 투자 결정 기대" },
      { date: "2026-11", text: "대형원전 Long Lead Items(장납기 기자재) 발주 시작 · Palisades SMR-300 부분 착공" },
      { date: "2027~2028", text: "대형원전 FID(최종투자결정) 집중 전망" },
    ],
  },
};
